import React from 'react';
import PaddingBox from '../../../../components/PaddingBox';
import classes from './styles/index.module.scss';
import { ExclamationCircleO } from '../../../../components/Icons/ExclamationCircleO';

const AuthenticationConfirmationBoxMessage = ({ message, renderButtons }) => (
	<PaddingBox
		topSmall
		bottomTiny
	>
		<div className={classes.authenticationSuccessMessage}>
			<ExclamationCircleO className={classes.icon} />
			<div className={classes.message}>{message}</div>
		</div>
		<PaddingBox topSmall>{renderButtons}</PaddingBox>
	</PaddingBox>
);

export { AuthenticationConfirmationBoxMessage };
